import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, nextTick } from 'vue';
import { type MonthCell } from '../../datepicker';


const __default__ = {
    name: 'UiDatepickerMonth',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    viewYear: null,
    monthCells: null,
    yearRange: null,
    showYearPicker: { type: Boolean, default: false }
  },
  emits: ["prev-year", "next-year", "toggle-year-picker", "select-month", "month-hover", "month-leave", "select-year"],
  setup(__props: any) {

const props = __props as { viewYear: number, monthCells: MonthCell[], yearRange: number[], showYearPicker: boolean }





const yearListRef = ref<HTMLElement | null>(null);

watch(() => props.showYearPicker, (open) => {
    if (!open) return;
    nextTick(() => {
        const el = yearListRef.value?.querySelector<HTMLElement>(`[data-year="${props.viewYear}"]`);
        el?.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
});

return { __sfc: true,props, yearListRef }
}

})